import React, { useEffect, useState } from 'react';
import { BankAccount, OnboardingStageProps } from '../../Classes';
import { Button, Header, Icon, Message, Toast } from 'react-frontier';
import BankAccountModal from '../../components/BankAccountModal';
import { bindClick } from '@tempu/components/Util';

var OnboardingBank = (props: OnboardingStageProps)=>{
	var [addModal, setAddModal] = useState<boolean>(false);

	var onAccountCreate = (account: BankAccount)=>{
		var usr = {...props.user};
		if(!usr.accounts) usr.accounts = [];
		usr.accounts.push({
			account_id: account.account_id,
			bank: account.bank,
			card_number: account.card_number,
			clabe: account.clabe,
			curp: account.curp,
			name_account: account.name_account,
			postal_code: account.postal_code,
			primary_account: account.primary_account,
			rfc: account.rfc,
		});
		props.setUser(usr);
		setAddModal(false);
		Toast.success('Se ha agregado la cuenta bancaria');
	}

	var nextStep = ()=>{
		props.onFinish();
	}
	
	return <div className="tp onboarding-bank">
		<Header text={'Cuenta bancaria'} subtext={'Tu información bancaria donde se realizarán tus pagos'} />
		<Button onClick={bindClick(setAddModal, true)} text='Agregar cuenta' color='black' style={{ display: 'block', maxWidth: 200, margin: 'auto', marginBottom: 10 }} />
		{!props.user.accounts || props.user.accounts.length==0 ? (
			<div className="tp placeholder card" style={{ display: 'flex', justifyContent: 'center' }}>
				<Header
					centered
					iconName='landmark'
					text={'Sin cuentas bancarias'}
					subtext={'Favor de agregar una cuenta bancaria'}
				/>
			</div>
		) : <>
			{props.user.accounts.map(a=>(
				<div className="tp card account">
					<Icon name={a.clabe ? 'landmark' : 'credit-card'} />
					<div className="left">
						{!!a.primary_account && (
							<div className="primary">Cuenta primaria</div>
						)}
						<div className="title">
							{a.clabe ? <>
								<b>SPEI</b> **{a.clabe.slice(-5)}
							</> : <>
								<b>{a.bank}</b> **{a.card_number.slice(-4)}
							</>}
						</div>
						<div className="name">{a.name_account}</div>
					</div>
				</div>
			))}
			<Message centered>
				Tu <b>cuenta primaria</b> será la cuenta a la cual se le realizarán los <b>depositos automáticos</b> de los pagos de tus trabajos.
				<br /> <br />
				Podrás agregar mas cuentas y cambiar tu cuenta primaria en cualquier momento en la configuración de tu cuenta.
			</Message>
		</>}
		<div className="actions">
			<Button disabled={props.user.accounts.length==0} color='black' text='Continuar' onClick={nextStep} />
		</div>
		<BankAccountModal
			open={addModal}
			forcePrimary={props.user.accounts.length===0}
			onCreate={onAccountCreate}
			onClose={bindClick(setAddModal, false)}
		/>
	</div>
}

export default OnboardingBank;